import { styled } from "@linaria/react"
import { motion } from "framer-motion"

export const MessageList = styled(motion.div)`
  max-width: var(--chat-width);
`
